import React from 'react';
import { ProtectedRoute as SharedProtectedRoute } from '@nova-integration/ui-shared';
import { useAuthStore } from '../stores/authStore';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <SharedProtectedRoute useAuthStore={useAuthStore}>{children}</SharedProtectedRoute>
);
